
define('text!common/views/commercial/outbrain.html',[],function () { return '<div class="OUTBRAIN" data-widget-id="<%=widgetCode%>" data-ob-template="guardian"></div>';});

